export const linkFacebook = 'https://www.facebook.com/paozinhodoceu/';
export const linkInstagram = 'https://www.instagram.com/paozinhodoceu/';
export const linkWhatsApp = 'https://api.whatsapp.com/send?phone=557191375233';
